export default __webpack_public_path__ + "static/media/pastel-desktop.d24090a8.jpg";